import { ref, type Ref } from 'vue';
import { RECOVERY_STORAGE_KEY } from './constants';

export interface RecoveryController {
  isRecoverySession: Ref<boolean>;
  setRecoveryMode: (value: boolean) => void;
  hydrateRecoveryFlag: () => void;
}

const persistFlag = (value: boolean): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (value) {
    sessionStorage.setItem(RECOVERY_STORAGE_KEY, '1');
  } else {
    sessionStorage.removeItem(RECOVERY_STORAGE_KEY);
  }
};

const hydrateFlag = (target: Ref<boolean>): void => {
  if (typeof window === 'undefined') {
    return;
  }

  if (sessionStorage.getItem(RECOVERY_STORAGE_KEY) === '1') {
    target.value = true;
  }
};

export const createRecoveryController = (): RecoveryController => {
  const isRecoverySession = ref(false);

  const setRecoveryMode = (value: boolean): void => {
    isRecoverySession.value = value;
    persistFlag(value);
  };

  const hydrateRecoveryFlag = (): void => {
    hydrateFlag(isRecoverySession);
  };

  return {
    isRecoverySession,
    setRecoveryMode,
    hydrateRecoveryFlag
  };
};


